export const APPLICANTS_STAGE_FILTER_KEY_PREFIX = "june:applicantsStageFilter:";

export function stageFilterStorageKey(jobId) {
  return `${APPLICANTS_STAGE_FILTER_KEY_PREFIX}${jobId}`;
}

export function readSavedStageFilter(jobId) {
  if (!jobId || typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(stageFilterStorageKey(jobId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      selected: Array.isArray(parsed.selected) ? parsed.selected : [],
      knownOptions: Array.isArray(parsed.knownOptions) ? parsed.knownOptions : [],
      stageUserClearedAll: Boolean(parsed.stageUserClearedAll),
    };
  } catch {
    return null;
  }
}

export function writeSavedStageFilter(
  jobId,
  selectedNames,
  stageUserClearedAll,
  knownOptions = []
) {
  if (!jobId || typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      stageFilterStorageKey(jobId),
      JSON.stringify({
        selected: Array.from(selectedNames || []),
        knownOptions: Array.from(knownOptions || []),
        stageUserClearedAll: Boolean(stageUserClearedAll),
      })
    );
  } catch {
    // Ignore quota / private-mode failures.
  }
}

export function mergeStageFilterWithOptions(
  savedSelected,
  optionValues,
  stageUserClearedAll,
  knownOptions = []
) {
  if (stageUserClearedAll) {
    return new Set();
  }
  const options = optionValues || [];
  if (!savedSelected) {
    return new Set(options);
  }
  const saved = new Set(savedSelected);
  const previouslyKnown = new Set(knownOptions || []);
  const next = new Set();
  for (const name of options) {
    if (saved.has(name) || !previouslyKnown.has(name)) {
      next.add(name);
    }
  }
  return next;
}

export function buildShowAllStageFilter(optionValues) {
  return new Set(optionValues || []);
}

const TERMINAL_STAGE_HINTS = [
  "rejected",
  "hired",
  "offer",
  "declined",
  "withdrawn",
];

export function stageLooksTerminal(stageName) {
  const lower = (stageName || "").trim().toLowerCase();
  if (!lower) return false;
  return TERMINAL_STAGE_HINTS.some((hint) => lower.includes(hint));
}

export function applicantStageIsOutsideEligible(stageName, eligibleNames) {
  if (eligibleNames == null) return false;
  const trimmed = (stageName || "").trim();
  if (!trimmed) return true;
  const allow = new Set(
    (eligibleNames || []).map((name) => String(name || "").trim()).filter(Boolean)
  );
  return !allow.has(trimmed);
}
